export enum GrowthSignalsDataLabelsEnum {
  COMPANIES_EXPORTED = 'Companies Exported',
  CONTACTS_EXPORTED = 'Contacts Exported',
  COMPANIES = 'Companies',
  CONTACTS = 'Contacts',
  ALL_COMPANIES = 'All Companies',
}
